var map = {
	"./antitank.svg": 2966,
	"./apc-driver.svg": 1008,
	"./assaulter.svg": 1705,
	"./backup/antitank.svg": 891,
	"./backup/apc-driver.svg": 98,
	"./backup/assaulter.svg": 9379,
	"./backup/engineer.svg": 1601,
	"./backup/flamethrower.svg": 4952,
	"./backup/medic.svg": 7334,
	"./backup/mg.svg": 1159,
	"./backup/mortar.svg": 7057,
	"./backup/moto.svg": 8588,
	"./backup/paratrooper.svg": 9155,
	"./backup/pilot-attacker.svg": 4794,
	"./backup/pilot-fighter.svg": 9175,
	"./backup/radio.svg": 1420,
	"./backup/rifleman.svg": 9388,
	"./backup/sniper.svg": 5201,
	"./backup/tank.svg": 574,
	"./backup/unknown.svg": 7608,
	"./engineer.svg": 9524,
	"./flamethrower.svg": 2510,
	"./medic.svg": 49,
	"./mg.svg": 4936,
	"./mortar.svg": 7463,
	"./moto.svg": 3143,
	"./paratrooper.svg": 4733,
	"./partisan.svg": 6752,
	"./pilot-attacker.svg": 1334,
	"./pilot-fighter.svg": 8869,
	"./radio.svg": 4438,
	"./rifleman.svg": 6353,
	"./sniper.svg": 893,
	"./tags.svg": 2417,
	"./tank.svg": 3221,
	"./unknown.svg": 7423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4052;